<template>
  <div class="checkbox-group-with-other">
    <el-checkbox-group :value="checkedLabels" @input="onPitchChange">
      <span v-for="(item, idx) in options" :key="`abc-${item.value}`" class="checkbox-item-wrap" :class="{ 'is-other': isOtherItem(item) }">
        <el-checkbox :label="item.value">
          {{ item.label }}
          <!-- other 项的 textarea（换行显示在选项下方） -->
          <span v-if="isOtherItem(item) && checkedLabels.includes(item.value)">
            <span v-for="(child, index) in othersData" :key="'child' + index">
              <span v-if="child.k === item.value" class="other-textarea-wrap">
                <el-input
                  type="textarea"
                  :rows="2"
                  :value="child.v"
                  @input="onOtherInput(index, $event)"
                  :placeholder="$t('common.placeholder.enter')"
                  class="wd200 fs12 lh36 vam"
                ></el-input>
              </span>
            </span>
          </span>
        </el-checkbox>
      </span>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  name: "CheckboxGroupWithOther",
  props: {
    /**
     * 绑定值（API 原生数组格式）
     * 示例: ["Savings from employment", { k: "Others, please specify", v: "aaaaa" }]
     */
    value: {
      type: Array,
      default: () => [],
    },
    /** 选项列表，每项格式 { value: string, label: string } */
    options: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    /** 已选中的标签字符串列表（用于 el-checkbox-group） */
    checkedLabels() {
      return (this.value || []).map(item => {
        return typeof item === "object" && item.k ? item.k : String(item);
      });
    },
    /** 从 value 中提取的 others 数据 */
    othersData() {
      const otherKeys = this.options.filter(i => this.isOtherItem(i)).map(i => i.value);
      return (this.value || []).filter(item => typeof item === "object" && item.k && otherKeys.includes(item.k));
    },
    /** 预构建的 others 模板（用于未选中的 other 项占位） */
    othersTemplate() {
      return this.options.filter(i => this.isOtherItem(i)).map(i => ({ k: i.value, v: "" }));
    },
  },
  methods: {
    isOtherItem(item) {
      return item.value.toLowerCase().includes("other");
    },
    /**
     * 将内部状态组装为 API 数组并 emit
     * @param {string[]} labels - 当前勾选的 label 数组
     */
    emitApiArray(labels) {
      const apiArr = [];
      // 先填充 others 模板
      const othersMap = {};
      this.othersTemplate.forEach(t => {
        othersMap[t.k] = { ...t };
      });

      // 用已有数据覆盖
      (this.othersData || []).forEach(o => {
        if (othersMap[o.k]) {
          othersMap[o.k] = o;
        }
      });

      labels.forEach(val => {
        if (this.isOtherItem({ value: val })) {
          // other 项：输出对象
          apiArr.push(othersMap[val] || { k: val, v: "" });
        } else {
          // 普通项：输出字符串
          apiArr.push(val);
        }
      });

      this.$emit("input", apiArr);
    },

    onPitchChange(val) {
      this.emitApiArray(val || []);
    },
    onOtherInput(index, val) {
      // 更新对应 other 的值后重新组装 emit
      const newOthers = [...(this.othersData || [])];
      newOthers[index] = { ...newOthers[index], v: val };
      // 将新 others 合入当前 value 后重新 emit
      const currentChecked = [...this.checkedLabels];
      const apiArr = [];
      const othersMap = {};
      newOthers.forEach(o => {
        othersMap[o.k] = o;
      });
      currentChecked.forEach(val => {
        if (this.isOtherItem({ value: val })) {
          apiArr.push(othersMap[val] || { k: val, v: "" });
        } else {
          apiArr.push(val);
        }
      });
      this.$emit("input", apiArr);
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox-group-with-other {
  width: 100%;
}
.checkbox-item-wrap {
  display: inline-block;
  vertical-align: top;
}
</style>
